export default "__VITE_ASSET__Dx6M$34I__"